import { render, staticRenderFns } from "./BrowserWindow.vue?vue&type=template&id=fc135ec6"
import script from "./BrowserWindow.vue?vue&type=script&lang=ts"
export * from "./BrowserWindow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports